import React from "react";
import { Svg } from "../componet/Form/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      fill="none"
      viewBox="0 0 14 13"
      pencil="true"
    >
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M7.354 12.033h5.758M10.233 1.477a1.357 1.357 0 111.92 1.919l-7.998 7.997-2.559.64.64-2.56 7.997-7.996z"
      ></path>
    </Svg>
  );
}

export default Icon;
